import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject, timer } from 'rxjs';

import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
  styles: [],
  template: `
    <div class="mb-4">
      You will be logged out in {{ secondsLeft | async }} seconds due to inactivity and all
      <br />
      unsaved changes will be lost. Please select “Stay Logged In” to
      <br />
      extend your session.
    </div>

    <div class="flex items-center justify-between">
      <button type="button" class="btn btn--secondary" (click)="ref.close('logout')">
        Log Out
      </button>

      <button type="button" class="btn btn--primary" (click)="ref.close()">Stay Logged In</button>
    </div>
  `,
})
export class TimeoutDialogComponent {
  ref = inject<CustomOverlayRef<'logout' | undefined>>(CustomOverlayRef);
  secondsLeft = new BehaviorSubject(90);

  constructor() {
    const ref = this.ref;

    timer(0, 1000)
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        const remaining = this.secondsLeft.getValue();

        if (remaining <= 0) {
          ref.close('logout');

          return;
        }

        this.secondsLeft.next(remaining - 1);
      });
  }
}
